import * as React from "react";
import { SVGProps } from "react";
const SvgWater = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4c.357 0 .65.216.866.5C20.786 9.65 24 16 24 19c0 4.398-3.563 8-8 8-4.437 0-8-3.602-8-8 0-3 3.214-9.35 7.134-14.5.216-.284.509-.5.866-.5Zm6 15h-2a4.012 4.012 0 0 1-2 3.464l1 1.732A6.016 6.016 0 0 0 22 19Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWater;
